import { useState, useEffect, useCallback } from "react";
import authService from "../../services/auth-service";
import BTBox from "../../components/BTBox";
import BTButton from "../../components/BTButton";
import BTInput from "../../components/BTInput";
import DashboardLayout from "../../Layouts/Layoutcontainers";
import EnhancedTable from "../../components/BTTable";
import { AssessmentOutlined, Delete, Error } from "@mui/icons-material";
import {
  Card,
  Tooltip,
  Zoom,
  IconButton,
  FormControlLabel,
  Switch,
  TextField,
  Autocomplete,
} from "@mui/material";
import Addreturned from "./Addreturned.js";
import Summary from "./Summary.js";
import ConfirmBox from "../../components/ConfirmBox";
import { returned_status } from "../../dropdownData/index.js";
import moment from "moment";
import { useLoading, useNotification } from "../../context";
import { useDispatch, useSelector } from "react-redux";
import {
  get_parties,
  get_cnv_rates,
  get_sizes,
  sendMail,
} from "../../store/functions.js";
import { get } from "../../store/labSlice.js";
import { fetchData } from "../../utils/fetchData.js";
const default_search = {
  type: 1,
  p_id: null,
  from_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
  to_date: moment().add(1).format("YYYY-MM-DD"),
  rowsPerPage: 50,
  page: 1,
  searchText: null,
  last_id: 0,
  isSub: false,
  p_ret_id: null,
};
const CardHeader = ({
  setOpen,
  search,
  setSearch,
  tableType,
  setTableType,
  parties,
  clearState,
}) => {
  const [localDates, setLocalDates] = useState({
    from_date: search?.from_date || "",
    to_date: search?.to_date || "",
  });
  const handleDateChange = (field, value) => {
    const newDates = { ...localDates, [field]: value };
    setLocalDates(newDates);
    const timer = setTimeout(() => {
      clearState();
      setSearch({
        ...search,
        from_date: newDates.from_date,
        to_date: newDates.to_date,
        page: 1,
      });
    }, 500);

    return () => clearTimeout(timer);
  };

  return (
    <Card sx={{ mb: 1 }}>
      <BTBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
        }}>
        <BTBox
          display="flex"
          alignItems="center"
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1,
            width: { xs: "100%", sm: "auto" },
          }}>
          <FormControlLabel
            control={
              <Switch
                checked={tableType}
                onChange={() => {
                  clearState();
                  setTableType(!tableType);
                  setSearch({
                    ...default_search,
                    type: tableType ? 1 : 2,
                  });
                }}
                size="small"
                color="secondary"
              />
            }
            label={"All records"}
            labelPlacement="end"
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          />
          <BTInput
            size="small"
            type="date"
            label="From Date"
            value={localDates.from_date}
            onChange={(e) => handleDateChange("from_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />

          <BTInput
            size="small"
            type="date"
            label="To Date"
            value={localDates.to_date}
            onChange={(e) => handleDateChange("to_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />
          {tableType && (
            <Autocomplete
              options={parties || []}
              getOptionLabel={(option) =>
                `${option.p_code} : ${option.p_name}` || ""
              }
              renderOption={(props, option) => (
                <li {...props}>{`${option.p_code} : ${option.p_name}`}</li>
              )}
              onChange={(event, value) => {
                clearState();
                setSearch({ ...search, p_id: value?.p_id, page: 1 });
              }}
              sx={{ width: "100%" }}
              value={parties?.find(({ p_id }) => p_id === search?.p_id) || null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Party"
                  size="small"
                  variant="standard"
                  sx={{ width: { xs: "100%", sm: "200px" } }}
                />
              )}
            />
          )}
        </BTBox>
        <BTBox>
          <BTButton
            variant="gradient"
            size="small"
            fullWidth
            color="dark"
            onClick={() => setOpen({ show: true, actionType: 1 })}
            sx={{ width: { xs: "100%", sm: "auto" } }}>
            Add
          </BTButton>
        </BTBox>
      </BTBox>
    </Card>
  );
};
const ExpandComponent = ({
  row,
  expandColumns,
  handleGenerateBill,
  returns,
  subRefresh,
}) => {
  const { addNotification } = useNotification();
  const { showLoading, hideLoading } = useLoading();
  const [subRecords, setSubRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState({
    type: 2,
    p_id: null,
    from_date: null,
    to_date: null,
    rowsPerPage: 500000000,
    page: 1,
    searchText: null,
    last_id: 0,
    isSub: true,
    p_ret_id: row?.ret_id,
  });

  useEffect(() => {
    const localSubs = returns?.filter(
      ({ p_ret_id, ret_type }) => ret_type === 2 && p_ret_id === row?.ret_id,
    );
    if (localSubs > 0) {
      setSubRecords(localSubs);
    } else {
      fetchSubs();
    }
  }, [row, returns, subRefresh]);

  const fetchSubs = async () => {
    try {
      const response = await fetchData({
        api: "get_returns",
        name: "return",
        key: "ret_id",
        searchParams: search,
        filterCallback: null,
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
        hold: false,
      });

      if (response?.status) {
        setSubRecords(response?.data);
      }
    } finally {
    }
  };

  return (
    <EnhancedTable
      loading={loading}
      rows={subRecords}
      columns={expandColumns}
      tableHeader={true}
      title="Labout Details"
      checkBoxSelected={true}
      selectedConfiguration={{
        bgColor: "white",
        buttons: [
          <BTButton
            color={"dark"}
            variant={"gradient"}
            size="small"
            onClick={handleGenerateBill}
            fullWidth
            sx={{ width: "150px" }}
            disabled={subRecords?.every(
              ({ ret_bill_status }) => ret_bill_status === 2,
            )}>
            generate bill
          </BTButton>,
          <BTButton
            color={"dark"}
            variant={"gradient"}
            size="small"
            onClick={(e, pcs) => {
              sendMail({
                pcs,
                type: "return",
                notification: addNotification,
                showLoading,
                hideLoading,
              });
            }}
            fullWidth
            sx={{ width: "100px" }}>
            send mail
          </BTButton>,
        ],
      }}
    />
  );
};

const Labout = () => {
  const { addNotification } = useNotification();
  const { showLoading, hideLoading } = useLoading();
  const dispatch = useDispatch();
  const parties = useSelector((state) => state?.lab?.parties);
  const conversionRate = useSelector((state) => state?.lab?.conversionRate);
  const sizes = useSelector((state) => state?.lab?.sizes);
  const returns = useSelector((state) => state?.lab?.return);
  const [subRefresh, setSubRefresh] = useState(false);
  const [open, setOpen] = useState(null);
  const [openSummary, setSummary] = useState(null);
  const [tableType, setTableType] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(default_search);
  let pageIndex = returns?.pages?.findIndex((p) => p.page === search.page);
  const startIndex = pageIndex !== -1 ? pageIndex * search.rowsPerPage : 0;
  const endIndex = startIndex + search.rowsPerPage;
  useEffect(() => {
    !parties?.is_fetch && get_parties();
    !conversionRate?.is_fetch && get_cnv_rates();
    !sizes?.is_fetch && get_sizes();
  }, []);
  useEffect(() => {
    fetchReturns();
  }, [search]);
  const handleSearch = (data, searchData) => {
    const filterBySearch = data?.filter((item) => {
      const searchText = searchData?.searchText?.toLowerCase().trim() || "";
      const matchText =
        !searchText?.trim() ||
        String(item?.report_number)?.includes(searchText) ||
        String(item.customer_ref_no)?.includes(searchText) ||
        String(item?.shape_name)?.includes(searchText) ||
        String(item?.description)?.includes(searchText);
      const matchFilters =
        item?.ret_type === searchData?.type &&
        (searchData?.p_id ? item?.p_id === searchData?.p_id : true) &&
        moment(item.ret_date, "YYYY-MM-DD").isBetween(
          moment(searchData?.from_date, "YYYY-MM-DD").startOf("day"),
          moment(searchData?.to_date, "YYYY-MM-DD").endOf("day"),
          null,
          "[]",
        );
      return matchText && matchFilters;
    });
    const paginateData = filterBySearch?.slice(startIndex, endIndex);
    return paginateData;
  };
  const fetchReturns = async () => {
    await fetchData({
      api: "get_returns",
      name: "return",
      key: "ret_id",
      searchParams: search,
      filterCallback: handleSearch,
      showLoading: () => setLoading(true),
      hideLoading: () => setLoading(false),
      hold: true,
    });
  };
  const clearState = () => {
    dispatch(
      get({
        name: "return",
        data: [],
        pages: [],
        total: 0,
        fetch: false,
      }),
    );
  };

  //   columns
  const expandColumns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "report_date",
      name: "Report Date",
      selector: (row) => row.report_date,
    },
    {
      id: "ret_date",
      name: "Return date",
      selector: (row) =>
        moment(row?.ret_date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      sortable: true,
    },
    {
      id: "stn_date",
      name: "Submission Date",
      selector: (row) =>
        moment(row?.stn_date, "YYYY-MM-DD").format("DD/MM/YYYY"),
    },
    {
      id: "bill_status",
      name: "Bill status",
      selector: (row) =>
        returned_status?.find(({ value }) => value === row?.ret_bill_status)
          ?.label,
    },
    {
      id: "report_number",
      name: "Report Number",
      selector: (row) => row.report_number,
    },
    {
      id: "p_name",
      name: "Party",
      selector: (row) => {
        const party = parties?.data?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_name;
      },
    },
    {
      id: "p_code",
      name: "Party code",
      selector: (row) => {
        const party = parties?.data?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_code;
      },
    },
    {
      id: "shape_name",
      name: "Shape Name",
      selector: (row) => row.shape_name,
    },
    {
      id: "weight",
      name: "Weight",
      selector: (row) => row.weight,
    },
    {
      id: "description",
      name: "Description",
      selector: (row) => row.description,
    },
    {
      id: "pol_or_pol_sym",
      name: "POL or Pol/Sym",
      selector: (row) => row.pol_or_pol_sym,
    },
    {
      id: "sym",
      name: "SYM",
      selector: (row) => row.sym,
    },
    {
      id: "cut_prop",
      name: "CUT-PROP",
      selector: (row) => row.cut_prop,
    },
    {
      id: "clarity",
      name: "Clarity",
      selector: (row) => row.clarity,
    },
    {
      id: "fluorescence",
      name: "Fluorescence",
      selector: (row) => row.fluorescence,
    },
    {
      id: "stn_prefix_ref_no",
      name: "Prefix No",
      selector: (row) => row?.stn_prefix_ref_no,
    },
    {
      id: "customer_ref_no",
      name: "Customer Ref No.",
      selector: (row) => row.customer_ref_no,
    },
    {
      id: "laserscribe",
      name: "Laserscribe",
      selector: (row) => row.laserscribe,
    },
    {
      id: "recheck",
      name: "Recheck",
      selector: (row) => row.recheck,
    },

    // {
    //   id: "actions",
    //   name: "Actions",
    //   selector: (row) => (
    //     <Tooltip title="Delete" TransitionComponent={Zoom}>
    //       <IconButton
    //         size="small"
    //         onClick={() => {
    //           if (row?.ret_bill_status === 2) {
    //             addNotification({
    //               icon: <Error color="white" />,
    //               title: "Error",
    //               message:
    //                 "Deletion is not allowed as this record is included in a drafted bill.",
    //               color: "error",
    //             });
    //             return;
    //           }
    //           setDelete(row);
    //         }}
    //       >
    //         <Delete fontSize="12px" color="error" />
    //       </IconButton>
    //     </Tooltip>
    //   ),
    //   width: "50px",
    //   bodyCellStyle: {
    //     padding: "0px",
    //   },
    // },
  ];
  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
      numeric: false,
      sortable: true,
    },
    {
      id: "sub_count",
      name: "Number of Stones",
      selector: (row) => row?.number_stones,
      sortable: true,
    },
    {
      id: "p_name",
      name: "Party",
      selector: (row) => {
        const party = parties?.data?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_name;
      },
    },
    {
      id: "p_code",
      name: "Party code",
      selector: (row) => {
        const party = parties?.data?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_code;
      },
    },
    {
      id: "sub_weight",
      name: "Weight",
      selector: (row) => row?.weight?.toFixed(2),
      sortable: true,
    },
    {
      id: "ret_date",
      name: "Date",
      selector: (row) =>
        moment(row?.ret_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY"),
      sortable: true,
    },
    // {
    //   id: "actions",
    //   name: "Actions",
    //   value: () => "",
    //   center: true,
    //   bodyCellStyle: {
    //     padding: "0px",
    //   },
    //   selector: (row) => (
    //     <>
    //       <Tooltip title="Delete" TransitionComponent={Zoom}>
    //         <IconButton
    //           size="small"
    //           onClick={() => {
    //             const data = labouts?.data?.filter(
    //               ({ p_ret_id }) => p_ret_id === row?.ret_id
    //             );
    //             if (data?.length > 0) {
    //               addNotification({
    //                 icon: <Error color="white" />,
    //                 title: "Error",
    //                 message:
    //                   "Deletion is not allowed as this record includes a sub-labouts.",
    //                 color: "error",
    //               });
    //               return;
    //             }
    //             setDelete(row);
    //           }}
    //         >
    //           <Delete fontSize="12px" color="error" />
    //         </IconButton>
    //       </Tooltip>
    //       {/* <Tooltip
    //         title="Bill"
    //         onClick={async () => {
    //           showLoading();
    //           await new Promise((resolve) => setTimeout(resolve, 1000));
    //           const submits = [];
    //           const returns = labouts?.data?.filter(
    //             ({ p_ret_id }) => p_ret_id === row?.ret_id
    //           );

    //           const data = returns?.map((item) => {
    //             const submissionItem = submissions?.data?.find(
    //               ({ stn_report_no }) =>
    //                 Number(stn_report_no) === Number(item["report_number"])
    //             );
    //             submits.push(submissionItem);
    //             const weight = item?.weight;
    //             const size = sizes?.data?.find(
    //               ({ size_from, size_to }) =>
    //                 weight >= size_from && weight <= size_to
    //             );
    //             return {
    //               ...item,
    //               ...submissionItem,
    //               size: size
    //                 ? `${Number(size?.size_from)?.toFixed(2)} - ${Number(
    //                     size?.size_to
    //                   )?.toFixed(2)}`
    //                 : null,
    //               size_id: size ? size?.size_id : null,
    //             };
    //           });
    //           hideLoading();
    //           setSummary({ data, submits, returns });
    //         }}
    //       >
    //         <IconButton size="small" color="success">
    //           <AssessmentOutlined fontSize="12px" />
    //         </IconButton>
    //       </Tooltip> */}
    //     </>
    //   ),
    //   width: "100px",
    // },
  ];

  // function
  function processData(billData, rate = 0) {
    return Object.keys(billData)?.map((key) => ({
      admin_u_id: billData[key][0]?.admin_u_id,
      ser_id: null,
      ser_name: null,
      ser_price_type: null,
      size_id: null,
      bill_prefix: null,
      bill_cts: null,
      bill_pcs: null,
      bill_rate: null,
      bill_type: 1,
      bill_status: 0,
      p_bill_id: null,
      bill_desc: null,
      bill_created_by: billData[key][0]?.bill_created_by,
      bill_updated_by: billData[key][0]?.bill_updated_by,
      bill_date: billData[key][0]?.bill_date,
      p_id: parseInt(key),
      sub_billing_lines: billData[key]?.map((row) => ({
        ...row,
        bill_total: row?.bill_amount * rate,
      })),
      bill_total: billData[key]
        ?.map((row) => ({
          ...row,
          bill_total: row?.bill_amount * rate,
        }))
        ?.reduce((total, item) => total + item?.bill_total, 0),
    }));
  }

  const handleGenerateBill = async (e, selectedPcs) => {
    showLoading();
    const todayDate = moment().format("YYYY-MM-DD");
    const todayRate =
      conversionRate?.data.find(
        (rate) => moment(rate.cnv_date).format("YYYY-MM-DD") === todayDate,
      )?.cnv_rate || 0;
    const pcses = selectedPcs?.filter(
      ({ ret_bill_status }) => ret_bill_status !== 2,
    );

    try {
      const response = await authService?.processBillingData({
        attributes: {
          returns: pcses,
        },
      });
      if (response?.status_code === 200) {
        const data = processData(response?.data?.rows, todayRate);
        setSummary({
          bill_data: data,
          returns_data: pcses,
          parties: parties?.data,
          todayRate,
        });
      }
    } catch (error) {
      addNotification({
        message:
          error?.message?.message ||
          "Failed to connect to server. Please try again later.",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    } finally {
      hideLoading();
    }
  };
  const renderData = returns?.data?.filter(
    ({ ret_type }) => ret_type === search?.type,
  );

  return (
    <DashboardLayout>
      <CardHeader
        search={search}
        setSearch={setSearch}
        setOpen={setOpen}
        parties={parties?.data}
        clearState={clearState}
        tableType={tableType}
        setTableType={setTableType}
      />
      <EnhancedTable
        columns={tableType ? expandColumns : columns}
        loading={loading}
        tableHeader={true}
        rows={renderData?.slice(startIndex, endIndex)}
        title="Labout"
        defaultSort="carbs"
        pagination={true}
        expandComponent={
          <ExpandComponent
            expandColumns={expandColumns}
            returns={returns?.data}
            handleGenerateBill={handleGenerateBill}
            subRefresh={subRefresh}
          />
        }
        expandRow={tableType ? false : true}
        checkBoxSelected={tableType ? true : false}
        fetchData={{
          fnc: fetchData,
          params: {
            api: "get_returns",
            searchParams: {
              ...search,
              page: 1,
              rowsPerPage: returns?.total,
            },
            filterCallback: null,
            name: "return",
            key: "ret_id",
            showLoading,
            hideLoading,
            hold: false,
          },
        }}
        selectedConfiguration={{
          bgColor: "white",
          buttons: [
            <BTButton
              color={"dark"}
              variant={"gradient"}
              size="small"
              onClick={handleGenerateBill}
              fullWidth
              sx={{ width: "150px" }}
              disabled={returns?.data?.every(
                ({ ret_bill_status }) => ret_bill_status === 2,
              )}>
              generate bill
            </BTButton>,
            <BTButton
              color={"dark"}
              variant={"gradient"}
              size="small"
              onClick={(e, pcs) => {
                sendMail({
                  pcs,
                  type: "return",
                  notification: addNotification,
                  showLoading,
                  hideLoading,
                });
              }}
              fullWidth
              sx={{ width: "100px" }}>
              send mail
            </BTButton>,
          ],
        }}
        serverSidePagination={true}
        serverSideSearch={true}
        totalRows={returns?.total} // Total count across all pages
        onPageChange={({ page, rowsPerPage, searchText }) => {
          if (search?.rowsPerPage !== rowsPerPage) {
            clearState();
          }
          setSearch({
            ...search,
            page,
            rowsPerPage,
            searchText,
            last_id: returns?.pages[pageIndex]?.next_last_id,
          });
        }}
        onSearchChange={(searchText, { page, rowsPerPage }) => {
          clearState();
          setSearch((prev) => ({ ...prev, searchText, page, rowsPerPage }));
        }}
        initialPage={search?.page}
      />
      {Boolean(open) && (
        <Addreturned
          open={open}
          setOpen={setOpen}
          type={tableType}
          parties={parties?.data}
        />
      )}
      {/* {Boolean(isDelete) && (
        <ConfirmBox
          setDelete={setDelete}
          row={isDelete}
          name="labouts"
          id="ret_id"
          service={authService?.delete_return}
        />
      )} */}
      {Boolean(openSummary) && (
        <Summary summary={openSummary} setSummary={setSummary} sizes={sizes} />
      )}
    </DashboardLayout>
  );
};
export default Labout;
